export class UnpaidWageSearchFormValues {
  familyName = ''
  abn = ''
  entityName = ''
  recaptcha = ''
}

export const UnpaidWageSearchFieldMapping = new Map<string, string>([
  ['familyName', 'Family name'],
  ['abn', 'ABN'],
  ['entityName', 'Entity name'],
  ['recaptcha', 'Captcha'],
])

export const UnpaidWagePossibleMatchFieldMapping = new Map<string, string>([
  ['givenName', 'Given name'],
  ['familyName', 'Family name'],
  ['contactEmail', 'Contact email'],
  ['contactNumber', 'Contact number'],
])

export class UnpaidWagePossibleMatchFormValues {
  givenName = ''
  familyName = ''
  contactEmail = ''
  contactNumber = ''
  id = ''
}

export interface IUnpaidWagesProps {
  onSave: (id?: string) => void
  id?: string
}

export class UnpaidWageSearchSubmitRequest {
  familyName: string
  abn: string
  entityName: string
  recaptcha: string

  constructor(init?: UnpaidWageSearchFormValues) {
    this.familyName = init.familyName
    this.abn = init.abn
    this.entityName = init.entityName
    this.recaptcha = init.recaptcha
  }
}

export class UnpaidWageSearchSubmitDetailsRequest {
  id: string
  familyName: string
  givenName: string
  contactEmail: string
  contactNumber: string

  constructor(init?: UnpaidWagePossibleMatchFormValues) {
    this.id = init.id
    this.familyName = init.familyName
    this.givenName = init.givenName
    this.contactEmail = init.contactEmail
    this.contactNumber = init.contactNumber
  }
}

export interface UnpaidWageSearchSubmitResponse {
  id: string
}
